import { render, staticRenderFns } from "./DetailsRequisition.vue?vue&type=template&id=28e9b127&lang=pug&"
import script from "./DetailsRequisition.vue?vue&type=script&lang=js&"
export * from "./DetailsRequisition.vue?vue&type=script&lang=js&"
import style0 from "./DetailsRequisition.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports